// TODO: There's no good reason for these skill names like "fetchAndSwitch" to be hard-coded keys, coincidentally matching the skill config keys.
// TODO: Those keys should be fetched from the skill configs themselves, or perhaps better yet, these values should simply be in the skills configs directly.
// - It just seems like more unecessary maintenance to keep them here, later having to match them up.
export const effectSources = {
  damageReceiptPlus: {
    damageReceiptPlus: {
      value: 1.4
    }
  },
  fetchAndSwitch: {
    lure: {}
  },
  buryBone: {
    breakArmourMech: {
      value: 0.4
    },
    slow: {
      value: 0.3
    },
    duration: 3000
  },
  positiveFeedback: {
    sumCoreSkillSpeedScalar: {
      value: 0.75
    },
    sumCoreSkillPowerRaw: {
      value: 0.3
    },
    duration: 4000
  },
  supersonicBark: {
    fear: {},
    duration: 1000
  },
  counterCower: {
    fear: {},
    duration: 1000
  },
  superHairball: {
    slow: {}
  },
  roadHog: {
    stun: {},
    duration: 1500
  },
  curlyCorkPulse1: {
    stun: {},
    duration: 1500
  },
  curlyCorkPulse2: {
    disarm: {},
    duration: 3000
  },
  curlyCorkPulse3: {
    silence: {},
    duration: 3000
  },
  slobSludge_buff: {
    buffArmourElec: {
      value: 1
    }
  },
  slobSludge_debuff: {
    slow: {
      value: 0.5
    },
    duration: 5000
  },
  cavalryCharge_debuff: {
    breakArmourMech: {
      value: 0.2
    },
    duration: 3500
  },
  vacuumSneeze: {
    root: {},
    duration: 1500
  },
  buckleUp: {
    stun: {},
    untargetable: {}
  },
  baahBlitz: {
    roleSkillDmgReceiptPlus: {
      value: 0.2
    },
    duration: 7000
  },

  // Immunities
  invulnerable: {
    unbreakable: {},
    secureInput: {}
  },
  unstoppable: {
    secureInput: {}
  }
} as const;
